<template>
    <div class="record-participants loading-content-container">
        <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <div v-if="!isLoading">
            <b-row>
                <b-col cols="8">
                    <b-row v-if="initialFormContexts.participantsAdversary.isLoaded" class="mb-4">
                        <csp-desktop-participants-adversary
                            :form-context="initialFormContexts.participantsAdversary"
                            @reload-participants="loadParticipants"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsDriverAdversary.isLoaded" class="mb-4">
                        <csp-desktop-participants-driver-adversary
                            :form-context="initialFormContexts.participantsDriverAdversary"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsDifferingPolicyholder.isLoaded" class="mb-4">
                        <csp-desktop-participants-differing-policyholder
                            :form-context="initialFormContexts.participantsDifferingPolicyholder"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsDriverCustomer.isLoaded" class="mb-4">
                        <csp-desktop-participants-driver-customer
                            :form-context="initialFormContexts.participantsDriverCustomer"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsPoliceStation.isLoaded" class="mb-4">
                        <csp-desktop-participants-police-station
                            :form-context="initialFormContexts.participantsPoliceStation"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsWitness.isLoaded" class="mb-4">
                        <csp-desktop-participants-witness
                            :form-context="initialFormContexts.participantsWitness"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsInjured.isLoaded" class="mb-4">
                        <csp-desktop-participants-injured
                            :form-context="initialFormContexts.participantsInjured"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsInvolvedPerson.isLoaded" class="mb-4">
                        <csp-desktop-participants-involved-person
                            :form-context="initialFormContexts.participantsInvolvedPerson"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsDefendant.isLoaded" class="mb-4">
                        <csp-desktop-participants-defendant
                            :form-context="initialFormContexts.participantsDefendant"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsClaimant.isLoaded" class="mb-4">
                        <csp-desktop-participants-claimant
                            :form-context="initialFormContexts.participantsClaimant"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsCasualtyLawyer.isLoaded" class="mb-4">
                        <csp-desktop-participants-casualty-lawyer
                            :form-context="initialFormContexts.participantsCasualtyLawyer"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsCasualtyAppraiser.isLoaded" class="mb-4">
                        <csp-desktop-participants-casualty-appraiser
                            :form-context="initialFormContexts.participantsCasualtyAppraiser"/>
                    </b-row>
                </b-col>
                <b-col cols="4">
                    <b-row v-if="initialFormContexts.participantsAppraiser.isLoaded" class="mb-4">
                        <csp-desktop-participants-appraiser
                            :form-context="initialFormContexts.participantsAppraiser"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsExternal.isLoaded" class="mb-4">
                        <csp-desktop-participants-external-service-provider
                            :form-context="initialFormContexts.participantsExternal"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsLawyer.isLoaded" class="mb-4">
                        <csp-desktop-participants-lawyer
                            :form-context="initialFormContexts.participantsLawyer"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsCardealer.isLoaded" class="mb-4">
                        <csp-desktop-participants-cardealer
                            :form-context="initialFormContexts.participantsCardealer"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsDifferingRepairFirm.isLoaded" class="mb-4">
                        <csp-desktop-participants-differing-repair-firm
                            :form-context="initialFormContexts.participantsDifferingRepairFirm"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsCarRentalCompany.isLoaded" class="mb-4">
                        <csp-desktop-participants-car-rental-company
                            :form-context="initialFormContexts.participantsCarRentalCompany"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsDSP.isLoaded" class="mb-4">
                        <csp-desktop-participants-dsp
                            :form-context="initialFormContexts.participantsDSP"/>
                    </b-row>
                    <b-row v-if="initialFormContexts.participantsReseller.isLoaded" class="mb-4">
                        <csp-desktop-participants-reseller
                            :form-context="initialFormContexts.participantsReseller"/>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '../mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';
    import ParticipantAdversary from '@desktop/components/record/participant/ParticipantAdversary.vue';
    import ParticipantDifferingPolicyholder
        from '@desktop/components/record/participant/ParticipantDifferingPolicyholder.vue';
    import ParticipantAppraiser from '@desktop/components/record/participant/ParticipantAppraiser.vue';
    import ParticipantDriverAdversary from '@desktop/components/record/participant/ParticipantDriverAdversary';
    import ParticipantDriverCustomer from '@desktop/components/record/participant/ParticipantDriverCustomer';
    import ParticipantLawyer from '@desktop/components/record/participant/ParticipantLawyer.vue';
    import ParticipantCardealer from '@desktop/components/record/participant/ParticipantCardealer.vue';
    import ParticipantDSP from '@desktop/components/record/participant/ParticipantDSP.vue';
    import ParticipantReseller from '@desktop/components/record/participant/ParticipantReseller.vue';
    import ParticipantPoliceStation from '@desktop/components/record/participant/ParticipantPoliceStation.vue';
    import ParticipantWitness from '@desktop/components/record/participant/ParticipantWitness.vue';
    import ParticipantInjured from '@desktop/components/record/participant/ParticipantInjured.vue';
    import ParticipantInvolvedPerson from '@desktop/components/record/participant/ParticipantInvolvedPerson.vue';
    import ParticipantExternal from '@desktop/components/record/participant/ParticipantExternal.vue';
    import ParticipantDefendant from '@desktop/components/record/participant/ParticipantDefendant.vue'
    import ParticipantClaimant from '@desktop/components/record/participant/ParticipantClaimant.vue'
    import ParticipantCasualtyLawyer from '@desktop/components/record/participant/ParticipantCasualtyLawyer.vue';
    import ParticipantCasualtyAppraiser from '@desktop/components/record/participant/ParticipantCasualtyAppraiser.vue';
    import ParticipantDifferingRepairFirm
        from '@desktop/components/record/participant/ParticipantDifferingRepairFirm.vue';
    import ParticipantCarRentalCompany from '@desktop/components/record/participant/ParticipantCarRentalCompany.vue';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'RecordParticipants',
        components: {
            'csp-desktop-participants-adversary': ParticipantAdversary,
            'csp-desktop-participants-driver-adversary': ParticipantDriverAdversary,
            'csp-desktop-participants-driver-customer': ParticipantDriverCustomer,
            'csp-desktop-participants-differing-policyholder': ParticipantDifferingPolicyholder,
            'csp-desktop-participants-appraiser': ParticipantAppraiser,
            'csp-desktop-participants-external-service-provider': ParticipantExternal,
            'csp-desktop-participants-lawyer': ParticipantLawyer,
            'csp-desktop-participants-cardealer': ParticipantCardealer,
            'csp-desktop-participants-differing-repair-firm': ParticipantDifferingRepairFirm,
            'csp-desktop-participants-dsp': ParticipantDSP,
            'csp-desktop-participants-reseller': ParticipantReseller,
            'csp-desktop-participants-police-station': ParticipantPoliceStation,
            'csp-desktop-participants-witness': ParticipantWitness,
            'csp-desktop-participants-injured': ParticipantInjured,
            'csp-desktop-participants-involved-person': ParticipantInvolvedPerson,
            'csp-desktop-participants-defendant': ParticipantDefendant,
            'csp-desktop-participants-claimant': ParticipantClaimant,
            'csp-desktop-participants-casualty-lawyer': ParticipantCasualtyLawyer,
            'csp-desktop-participants-casualty-appraiser': ParticipantCasualtyAppraiser,
            'csp-desktop-participants-car-rental-company': ParticipantCarRentalCompany,
        },
        mixins: [FormDataMixin],
        data() {
            return {
                recordId: this.$route.params.recordId,
                isLoading: true,
                initialFormContexts: {
                    participantsAdversary: new FormContext({
                        name: 'participantsAdversary',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsDifferingPolicyholder: new FormContext({
                        name: 'participantsDifferingPolicyholder',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsDriverAdversary: new FormContext({
                        name: 'participantsDriverAdversary',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsDriverCustomer: new FormContext({
                        name: 'participantsDriverCustomer',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsDifferingRepairFirm: new FormContext({
                        name: 'participantsDifferingRepairFirm',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsAppraiser: new FormContext({
                        name: 'participantsAppraiser',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsExternal: new FormContext({
                        name: 'participantsExternalServiceProviders',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsLawyer: new FormContext({
                        name: 'participantsLawyer',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsCardealer: new FormContext({
                        name: 'participantsCardealer',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsDSP: new FormContext({
                        name: 'participantsDSP',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsReseller: new FormContext({
                        name: 'participantsReseller',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsPoliceStation: new FormContext({
                        name: 'participantsPoliceStation',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsWitness: new FormContext({
                        name: 'participantsWitness',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsInjured: new FormContext({
                        name: 'participantsInjured',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsInvolvedPerson: new FormContext({
                        name: 'participantsInvolvedPerson',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsDefendant: new FormContext({
                        name: 'participantsDefendant',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsClaimant: new FormContext({
                        name: 'participantsClaimant',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsCasualtyLawyer: new FormContext({
                        name: 'participantsCasualtyLawyer',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsCasualtyAppraiser: new FormContext({
                        name: 'participantsCasualtyAppraiser',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                    participantsCarRentalCompany: new FormContext({
                        name: 'participantsCarRentalCompany',
                        objectId: this.recordId,
                        reloadFields: [],
                    }),
                },
            };
        },
        created() {
            this.loadParticipants();
        },
        methods: {
            loadParticipants() {
                const loadFunction = () => {
                    return recordRepository.loadParticipants(this.recordId);
                }

                this.loadFormData(loadFunction).finally(() => {
                    this.isLoading = false;
                });
            },
        },
    };
</script>
